<template>
  <div class="goOrder cont_bg">
    <navs :lang="false" :saver="false" :mess="true"/>

    <div class="wallet_info_con">
      <div class="l">
        <p>${{ goOrderData?.price }}</p>
        <span>{{ $t('cont.t14') }}</span>
      </div>
      <div class="r" @click="$router.push('/recharge')">
        <i class="material-icons">add</i>
      </div>
    </div>
    <div style="padding: 0 .35rem">
      <div class="info">
        <div class="info_top">
          <div class="info_top_item">
            <div class="num">
              <!--全部-->
              {{ goOrderData?.order_num || 0 }}
            </div>
            <div class="title">
              {{ $t('cont.t02') }}
            </div>
          </div>
          <div class="info_top_item">
            <div class="num">
              <!--已完成-->
              {{ goOrderData?.day_d_count || 0 }}
            </div>
            <div class="title">
              {{ $t('cont.t04') }}
            </div>
          </div>

          <div class="info_top_item">
            <div class="num">
              <!--未完成-->
              {{ goOrderData?.order_num - goOrderData?.day_d_count || 0 }}
            </div>
            <div class="title">
              {{ $t('cont.t07') }}
            </div>
          </div>
        </div>
        <div class="info_con">
          <div>
            <div class="num">
              ${{ goOrderData?.day_deal || 0 }}
            </div>
            <div class="title">
              {{ $t('cont.t10') }}
            </div>
          </div>
          <div>
            <div class="num">
              {{ goOrderData?.day_d_count }}
            </div>
            <div class="title">
              {{ $t('cont.t11') }}
            </div>
          </div>
        </div>
        <div class="info_con">
          <div>
            <div class="num">
              ${{ goOrderData?.price }}
            </div>
            <div class="title">
              {{ $t('cont.t12') }}
            </div>
          </div>

        </div>
        <div class="info_bottom">
          <div class="btn" @click="go()">
            {{ btnText }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="gif">
      <img :src="src2" alt="">
    </div> -->
    <!--加载-->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <img :src="src1" alt="">
        </div>
      </div>
    </van-overlay>
    <!--弹窗-->
    <van-dialog v-model="dialog.type" show-confirm-button @confirm="dialogSuccess()" confirm-button-color="#007aff" :confirmButtonText="$t('user.t42')">
      <img v-if="dialog.imageSrc" style="max-width: 100%" :src="dialog.imageSrc"/>
      <span v-else>{{ dialogInfo }}</span>
    </van-dialog>
    <!--订单弹窗-->
    <upOrder :show="upOrderDialog" v-if="upOrderDialog" :oid="orderOid" @data-sent="emitFun" @load="getInfo"/>
    <!--音频-->
    <audio ref="audioPlayer" src="@/assets/audioMu.mp3"></audio>
  </div>
</template>
<script>
import navs from "@/components/navs.vue";
import {SERVERTAPI} from "@/config";
import upOrder from "@/components/upOrder.vue";

export default {
  components: {
    navs,
    upOrder
  },
  data() {
    return {
      src1: require('@/assets/image/end.gif'),
      src2: require('@/assets/image/sdascss.gif'),
      apiSrc: SERVERTAPI,
      tabsActive: 1,
      show: false,  // 加载弹窗
      dialog: {
        type: false,
        imageSrc: ''
      }, // 弹窗
      goOrderData: {},
      upData: {
        token: '',
        v: '',
        real: 0,
        countdown: 0, // 或者你需要的初始值
        cid: 1,
        add_id: '',
      },
      btnText: this.$t('cont.t13'),
      successData: {}, // 返回成功
      dialogInfo: '',
      upOrderDialog: false, // 订单弹窗
      orderOid: ''
    }
  },
  mounted() {

  },
  destroyed() {

  },
  created() {
    this.getInfo();
  },
  computed: {},
  methods: {
    getInfo() {
      this.$http.getGoOrderindex().then(res => {
        this.goOrderData = res.data;
      })
    },
    go() {
      this.upData.countdown = 3;
      // 加载动画
      this.show = true;
      this.btnText = this.$t('cont.t27');
      this.start(3);
      // Dialog.alert({
      //   message: '弹窗内容',
      // }).then(() => {
      // });
    },
    start(v, real) {
      this.upData.real = real || 0;
      this.upData.v = v;
      this.startRequest();
    },
    startRequest() {
      if (this.upData.countdown <= 0) {
        this.$http.getGoSubmit({
          real: this.upData.real
        })
            .then(res => {
              this.show = false;
              if (res.code === 0 && res.oid) {
                this.$refs.audioPlayer.play();
                this.$toast(this.$t('cont.t28'));
                this.successData = res.data;
                this.btnText = this.$t('cont.t13');
                this.orderOid = res.oid;
                // setTimeout(() => {
                  this.upOrderDialog = true;  // 打开订单详情弹窗
                // }, 400)
              } else if (res.code === 1) {
                this.btnText = this.$t('cont.t13');
                if (res.data && res.data.hasOwnProperty('image')) {
                  this.dialog.type = true;
                  this.dialog.imageSrc = res.data.image;
                } else {
                  this.dialog.type = true;
                  this.dialogInfo = res.info;
                }
              }
            })
            .catch(error => {
              this.show = false;
              this.$toast(this.$t('cont.t29'));
            })
      } else {
        this.upData.countdown--;
        setTimeout(this.startRequest, 1000);
      }
    },
    dialogSuccess() {
      if (this.dialog.imageSrc !== '') {
        this.start(1, 1);
      } else {
        this.$router.push('/order');
      }
    },

    // 订单弹窗回调
    emitFun(data) {
      this.upOrderDialog = !data;
    },
  },
}
</script>
<style lang='less' scoped>
.material-icons {
  color: #fff;
  font-size: .64rem;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .block {
    width: 4rem;
    height: 4rem;
    padding: .4rem;
    border-radius: .1rem;
    background-color: rgba(0, 0, 0, 0.8);

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.goOrder {
  min-height: 100vh;
  padding-top: 2.3rem;
  padding-bottom: 5rem;
  
  .wallet_info_con {
    display: flex;
    color: #fff;
    justify-content: space-between;
    padding: 0 .35rem;

    .l {
      display: flex;
      flex-direction: column;

      p {
        font-size: .7rem;
      }

      span {
        font-size: .36rem;
        opacity: .7;
      }
    }

    .r {
      width: 1.3rem;
      height: 1.3rem;
      background-color: #121212;
      border-radius: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        color: #fff;
        font-size: .5rem;
      }
    }
  }

  .info {
    margin-top: .5rem;
    border-radius: .24rem;
    overflow: hidden;
    background-color: white;

    .info_top {
      border-bottom-right-radius: .14rem;
      border-bottom-left-radius: .14rem;
      overflow: hidden;
      // background: linear-gradient(135deg, #DD585CFF 0%, #D44246 100%);
      background-color: #121212;
      display: flex;

      .info_top_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        color: #fff;
        padding: .9rem .3rem .3rem .3rem;

        .num {
          font-size: .7rem;
        }

        .title {
          font-size: .37rem;
        }
      }

    }

    .info_con {
      display: flex;
      border: #E5E5E5 .02rem solid;

      & > div {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: .37rem;

        .num {
          font-size: .37rem;
          font-weight: 700;
        }

        .title {
          font-size: .28rem;
          color: #666;
          margin-top: .05rem;
          opacity: .7;
        }
      }
    }

    .info_bottom {
      padding: .3rem .37rem;

      .btn {
        background-color:#121212;
        display: flex;
        padding: .25rem 0;
        border-radius: .45rem;
        justify-content: center;
        color: #fff;
        font-size: .4rem;
      }
    }
  }

  .gif {
    width: 100%;

    img {
      width: 100%;
    }
  }
}

::v-deep {
  .top {
    background-color: #121212;
    border-bottom: #444 .04rem solid;
  }

  .van-overlay {
    //background-color: rgba(0, 0, 0, .4);
  }

  .van-dialog__content {
    padding: .3rem 0;
    text-align: center;
    border: .02rem solid #eee;
  }
}


</style>
